export const EyeOpenedIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18 11C18 11 15.6 17 10 17C4.4 17 2 11 2 11C2 11 4.4 5 10 5C15.6 5 18 11 18 11Z"
      stroke="#14151A"
      strokeWidth="1.85"
    />
    <circle cx="10" cy="11" r="3" stroke="#14151A" strokeWidth="1.85" />
    <path d="M18.5 6.5C18.6953 6.30474 19 6 19 6" stroke="#141519" strokeWidth="1.6" strokeLinecap="round" />
    <path d="M1.5 6.5C1.30474 6.30474 1 6 1 6" stroke="#141519" strokeWidth="1.6" strokeLinecap="round" />
    <path d="M15 3.5L15.5 2.5" stroke="#141519" strokeWidth="1.6" strokeLinecap="round" />
    <path d="M5 3.5L4.5 2.5" stroke="#141519" strokeWidth="1.6" strokeLinecap="round" />
    <path d="M10.0005 2V1" stroke="#141519" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
)
